export default "__VITE_ASSET__DMRpy3t$__"